const FEATURE_HELP_URLS = {
  agent_bots: 'https://kb.astiostech.com/hc/agent-bots',
  agents: 'https://kb.astiostech.com/hc/agents',
  audit_logs: 'https://kb.astiostech.com/hc/audit-logs',
  campaigns: 'https://kb.astiostech.com/hc/campaigns',
  canned_responses: 'https://kb.astiostech.com/hc/canned',
  channel_email: 'https://kb.astiostech.com/hc/email',
  channel_facebook: 'https://kb.astiostech.com/hc/fb',
  custom_attributes: 'https://kb.astiostech.com/hc/custom-attributes',
  dashboard_apps: 'https://kb.astiostech.com/hc/dashboard-apps',
  help_center: 'https://kb.astiostech.com/hc/help-center',
  inboxes: 'https://kb.astiostech.com/hc/inboxes',
  integrations: 'https://kb.astiostech.com/hc/integrations',
  labels: 'https://kb.astiostech.com/hc/labels',
  macros: 'https://kb.astiostech.com/hc/macros',
  reports: 'https://kb.astiostech.com/hc/reports',
  sla: 'https://kb.astiostech.com/hc/sla',
  team_management: 'https://kb.astiostech.com/hc/teams',
  webhook: 'https://kb.astiostech.com/hc/webhooks',
  billing: 'https://kb.astiostech.com/pricing',
  saml: 'https://kb.astiostech.com/hc/saml',
  captain: 'https://kb.astiostech.com/captain-docs',
  captain_billing: 'https://kb.astiostech.com/hc/captain_billing',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
